<p class="crtw-px-0.5 sm:crtw-px-1.5 crtw-text-textMain crtw-text-[10px] sm:crtw-text-[11px]"><slot /></p>
